import {
  SET_INITIAL_FILTER_INFO,
  SET_CURRENT_FILTER_INFO,
  UPDATE_AIRLINE_FILTERS_UI
} from '../../../actions/actionTypes'

/* AIRLINES */
export const airlinesFilter = (state = [], action) => {
  const { type, payload = {}, meta = {} } = action
  switch (type) {
    case SET_INITIAL_FILTER_INFO:
      return (
        (payload.AIRLINES && payload.AIRLINES.map(slice => ({ ...slice }))) ||
        state
      )

    case SET_CURRENT_FILTER_INFO:
      return payload.airlinesFilter.map(slice => ({ ...slice }))

    case UPDATE_AIRLINE_FILTERS_UI:
      return state.map(airlineObj => {
        if (meta.isNoneClick) {
          airlineObj.checked = false
        } else if (meta.isAllClick) {
          airlineObj.checked = true
        } else if (meta.isOnlyClick) {
          airlineObj.checked = airlineObj.value === payload.value
        } else {
          airlineObj.checked =
            airlineObj.value === payload.value
              ? payload.checked
              : airlineObj.checked
        }
        return { ...airlineObj }
      })

    default:
      return state
  }
}
